import SimpleList from 'Components/SimpleList';
import SitesList from 'Components/SimpleList/Sites';
import { uniqBy } from 'lodash';
import React from 'react';
import { unixToDate } from 'utils/date';
import displayMetadata from 'utils/displayMetadata';

const generateReadingProperties = reading => {
    const
        sites = uniqBy(reading.measurements?.map(({ site_id, site_name }) => ({ id: site_id, name: site_name })), 'id') || [],
        organizations = uniqBy(reading.measurements?.map(({ organization_id, organization_name }) => ({ id: organization_id, name: organization_name })), 'id') || [];

    return [
        { label: 'ID', content: reading.id },
        { label: 'Name', content: reading.name },
        { label: 'Activate Measurement?', content: reading.activate_measurement ? 'Yes' : 'No' },
        { label: 'Create Indicator?', content: reading.create_indicator ? 'Yes' : 'No' },
        { label: 'Measurement Count', content: reading.measurements_count },
        { label: `Sites (${sites.length})`, content: <SitesList rows={sites}/> },
        { label: `Organizations (${organizations.length})`, content: organizations.map(({ name }) => name).sort().join(', ') },
        { label: 'Creation', content: `${reading.creator_name} @ ${unixToDate(reading.created_at)}` },
        { label: 'Update', content: `${reading.updater_name} @ ${unixToDate(reading.updated_at)}` }
    ];
};

const Details = props => {
    const { reading } = props;

    const content = [
        ...generateReadingProperties(reading),
        ...displayMetadata(reading)
    ];

    return (
        <SimpleList content={content}/>
    );
};

export default Details;
